import Cta from "@components/Cta/Cta";
import Grid from "@components/Grid/Grid";
import { ctaLink } from "@customTypes/generalLink";
import clsx from "clsx";
import { memo } from "react";
import styles from "./C261_Contact.module.scss";

export interface ContactDetailsProps {
  title: string;
  isExtended: boolean;
  isDark?: boolean;
  name: string;
  phoneNumber: string;
  emailAddress: string;
  ctaLink1: ctaLink;
  ctaLink2: ctaLink;
}

export const ContactDetails = (props: ContactDetailsProps) => {
  const { isExtended, isDark = true, name, phoneNumber, emailAddress, ctaLink1, ctaLink2 } =
    props;
  const ctaData = [ctaLink1, ctaLink2];

  const ContactLinks = () => (
    <>
      {phoneNumber && (
        <p className={clsx(styles["contact-link"], "whitespace-nowrap")}>
          <Cta
            linkText={phoneNumber}
            type="tertiary"
            url={`tel:${phoneNumber}`}
            light={isDark}
            icon="icon-call"
            contentClass="icon"
            openInNewTab
          />
        </p>
      )}
      {emailAddress && (
        <p className={styles["contact-link"]}>
          <Cta
            linkText={emailAddress}
            type="tertiary"
            url={`mailto:${emailAddress}`}
            light={isDark}
            icon="icon-email"
            contentClass=""
            openInNewTab
          />
        </p>
      )}
    </>
  );

  const ContactOptionalLinks = () => {
    return (
      <>
        {ctaData &&
          ctaData.map((cta, index) => {
            return cta && cta.linkText ? (
              <p key={`${cta.linkText}${index}`}>
                <Cta
                  {...cta}
                  type="tertiary"
                  light={isDark}
                  icon="icon-arrow-small"
                  contentClass="icon"
                />
              </p>
            ) : null;
          })}
      </>
    );
  };

  return (
    <>
      {!isExtended ? (
        <Grid column sm={12} md={6}>
          <h5>{name}</h5>
          <ContactLinks />
          <div className={styles["option-links"]}>
            <ContactOptionalLinks />
          </div>
        </Grid>
      ) : (
        <Grid row>
          <Grid column sm={12} lg={6}>
            <div className={styles["contact-details"]}>
              <ContactLinks />
            </div>
          </Grid>
          <Grid column sm={12} lg={6}>
            <div className={styles["contact-ctas"]}>
              <ContactOptionalLinks />
            </div>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default memo(ContactDetails);
